// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".about-us__social-stars[data-v-32399a22]{margin:0 auto;position:relative;height:300px;width:300px}.about-us__social-stars-first[data-v-32399a22]{position:absolute;left:0;z-index:1}.about-us__social-stars-second[data-v-32399a22]{position:absolute;top:40px;left:80px;right:0}.about-us__yellow-title[data-v-32399a22]{color:#e3dbb4}.about-us__button[data-v-32399a22]{max-width:400px;margin:0 auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
